import { render, staticRenderFns } from "./ChangeTemporaryPasswordView.vue?vue&type=template&id=3a688e03"
import script from "./ChangeTemporaryPasswordView.vue?vue&type=script&lang=ts"
export * from "./ChangeTemporaryPasswordView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports